export const API_URL = process.env.REACT_APP_API_URL
export const PINFLAG_BOT_URL = process.env.REACT_APP_PINFLAG_BOT_URL
export const COMPANY_API_URL = process.env.REACT_APP_COMPANY_API_URL
export const BUCKET_URL = process.env.REACT_APP_BASE_BUCKET_URL
export const TRACKING_ICONS_URL = process.env.REACT_APP_ICONS_TRACKING_BASE_URL
export const PINFLAG_PRIMARY_COLOR = '#33CCCC'
export const DELIVERY_ISSUE_CHECK_ICON = `${TRACKING_ICONS_URL}/check.svg`
export const DELIVERY_ISSUE_REPORTED_ICON = `${TRACKING_ICONS_URL}/fact_check.svg`

export const INACTIVE_ICONS_URL = `${TRACKING_ICONS_URL}/main-states/inactive`
export const PAGINATION_ICON_URL = `${TRACKING_ICONS_URL}/pagination`
export const NO_IMAGE_ICON = `${TRACKING_ICONS_URL}/sales/no-image.png`
export const SEARCH_ICON = `${TRACKING_ICONS_URL}/search-icon.svg`
export const MAIL_TEST_ICON = `${TRACKING_ICONS_URL}/mails-test.png`
export const MAIL_TEST_ICON_2 = `${TRACKING_ICONS_URL}/mails-test-2.jpeg`

export const TRACKING_ICON_SEARCH = 'tracking-icon.png'
export const TRACKING_FULL_ICON = 'tracking.png'
export const TRACKING_ACTIVE_1 = 'tracking-state-1.png'
export const TRACKING_ACTIVE_2 = 'tracking-state-2.png'
export const TRACKING_ACTIVE_3 = 'tracking-state-3.png'
export const TRACKING_ACTIVE_4 = 'tracking-state-4.png'
export const TRACKING_ACTIVE_5 = 'tracking-state-5.png'
export const TRACKING_INACTIVE_1 = '1.svg'
export const TRACKING_INACTIVE_2 = '2.svg'
export const TRACKING_INACTIVE_3 = '3.svg'
export const TRACKING_INACTIVE_4 = '4.svg'
export const TRACKING_INACTIVE_5 = '5.svg'

export const ERROR_ICON = `${TRACKING_ICONS_URL}/error.svg`

export const TRACKING_STEPS = {
  'bought': `${TRACKING_ICONS_URL}/states/shop_bag.svg`,
  'processed': `${TRACKING_ICONS_URL}/states/package_box.svg`,
  'in-transit': `${TRACKING_ICONS_URL}/states/hand_package.svg`,
  'on-delivery': `${TRACKING_ICONS_URL}/states/local_shipping.svg`,
  'received': `${TRACKING_ICONS_URL}/states/storefront.svg`,
  'stored': `${TRACKING_ICONS_URL}/states/storefront.svg`,
  'delivered': `${TRACKING_ICONS_URL}/states/approval_delegation.svg`
}

export const FOLLOW_PACKAGE_STEPS = {
  'bought': `${TRACKING_ICONS_URL}/states/shop_bag.svg`,
  'processed': `${TRACKING_ICONS_URL}/states/package_box.svg`,
  'in_transit': `${TRACKING_ICONS_URL}/states/hand_package.svg`,
  'on_delivery': `${TRACKING_ICONS_URL}/states/local_shipping.svg`,
  'received': `${TRACKING_ICONS_URL}/states/storefront.svg`,
  'stored': `${TRACKING_ICONS_URL}/states/storefront.svg`,
  'delivered': `${TRACKING_ICONS_URL}/states/approval_delegation.svg`
}

export const PERSON_ICON = `${TRACKING_ICONS_URL}/person.svg`

export const DELIVERY_TRUCK_ICON = `${TRACKING_ICONS_URL}/delivery_truck.svg`

export const CONTENT_PASTE_ICON = `${TRACKING_ICONS_URL}/content_paste_search.svg`

export const LOCATION_ICON = `${TRACKING_ICONS_URL}/location_on.svg`

export const EYE_ICON = `${TRACKING_ICONS_URL}/eye.svg`

export const HIDDEN_EYE_ICON = `${TRACKING_ICONS_URL}/hidden-eye.svg`

export const STOREFRONT_ICON = `${TRACKING_ICONS_URL}/storefront_black.svg`

export const DOWNLOAD_ICON = `${TRACKING_ICONS_URL}/download.svg`

export const FULLSCREEN_ICON = `${TRACKING_ICONS_URL}/fullscreen.svg`

export const GREEN_CHECK_ICON = `${TRACKING_ICONS_URL}/green-check.svg`

export const GRAY_CHECK_ICON = `${TRACKING_ICONS_URL}/gray-check.svg`

export const EMAIL_READ_ICON = `${TRACKING_ICONS_URL}/email_read.svg`

export const CALENDAR_CLOCK_ICON = `${TRACKING_ICONS_URL}/calendar_clock.svg`

export const VALIDATION_ERROR_ICON = `${TRACKING_ICONS_URL}/hide_source.svg`
